import { render, staticRenderFns } from "./AddPersonForm.vue?vue&type=template&id=7536d2e0&"
import script from "./AddPersonForm.vue?vue&type=script&lang=js&"
export * from "./AddPersonForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "AddPersonForm.vue"
export default component.exports